const SearchIcon = (props: { [key: string]: unknown }) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      // eslint-disable-next-line
      d="M15.15 14.089a.75.75 0 1 0-1.06 1.06l1.06-1.06Zm1.82 3.941a.75.75 0 1 0 1.06-1.06l-1.06 1.06Zm-2.88-2.88 2.88 2.88 1.06-1.06-2.88-2.881-1.06 1.06Zm-5.108-.437A5.732 5.732 0 0 1 3.25 8.982h-1.5a7.231 7.231 0 0 0 7.232 7.231v-1.5Zm5.731-5.731a5.732 5.732 0 0 1-5.731 5.731v1.5a7.232 7.232 0 0 0 7.231-7.232h-1.5ZM8.982 3.25a5.732 5.732 0 0 1 5.731 5.732h1.5A7.232 7.232 0 0 0 8.982 1.75v1.5Zm0-1.5A7.232 7.232 0 0 0 1.75 8.982h1.5A5.732 5.732 0 0 1 8.982 3.25v-1.5Z"
      fill="currentColor"
      opacity={0.5}
    />
  </svg>
);

export default SearchIcon;
